// src/components/utils/implements/CustomSelect.tsx
import React, { useState } from 'react';
import './CustomSelect.css';

interface CustomSelectProps {
    options: { label: string, value: string }[];
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
}

const CustomSelect: React.FC<CustomSelectProps> = ({ options, value, onChange, placeholder = "Seleccione una opción" }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleSelectOption = (selectedValue: string) => {
        onChange(selectedValue);
        setIsOpen(false);
    };

    return (
        <div className="custom-select">
            <div 
                className={`custom-select-trigger ${isOpen ? 'open' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                {options.find(option => option.value === value)?.label || placeholder}
                <span className="arrow">{isOpen ? '▲' : '▼'}</span>
            </div>
            {isOpen && (
                <div className="custom-select-options">
                    {options.map(option => (
                        <div
                            key={option.value}
                            className="custom-select-option"
                            onClick={() => handleSelectOption(option.value)}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomSelect;
